import md5 from "md5";
import Swal from "sweetalert2";
import i18n from "../i18n";
import { apiFetcher } from "../services/API.service";
import { decodeUserJWT, systemErrorAlertText } from "../utilities/utils";

export async function signupUser(
  email: string,
  referrerToken: string | null
): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  Swal.fire({
    title: i18n.t("Sending verification email"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });
  try {
    const response = await apiFetcher({
      route: "/auth/email",
      method: "POST",
      options: {
        body: {
          email: email,
          referrerToken: referrerToken
        }
      }
    });

    if (response.status === 202) {
      return { rStatus: "success" };
    }

    if (response.status === 209) {
      if (
        response.data &&
        typeof response.data === "object" &&
        "message" in response.data &&
        typeof response.data.message === "string"
      ) {
        if (response.data.message.toLowerCase() === "email") {
          return { rStatus: "error", message: i18n.t("Email already exists") };
        }
        if (response.data.message.toLowerCase() === "nickname") {
          return {
            rStatus: "error",
            message: i18n.t("Nickname already exists")
          };
        }
      }

      return { rStatus: "error", message: i18n.t("Account already exists") };
    }

    return { rStatus: "error", message: i18n.t("An error occurred") };
  } catch (error) {
    return { rStatus: "error", message: i18n.t("An error occurred") };
  }
}

export async function setUpAccount(
  email: string,
  username: string,
  name: string,
  surname: string,
  password: string,
  token: string
): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  Swal.fire({
    title: i18n.t("Setting up your account"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });

  const md5password = md5(password);
  console.log(md5password);
  const response = await apiFetcher({
    route: "/auth/signup",
    method: "POST",
    options: {
      body: {
        email: email,
        firstName: name,
        lastName: surname,
        password: md5password,
        nickname: username,
        emailToken: token
      }
    }
  });

  console.log(response, "response");

  if (response.status === 200) {
    if (
      response.data &&
      typeof response.data === "object" &&
      "refreshToken" in response.data &&
      typeof response.data.refreshToken === "string"
    ) {
      const refreshToken = response.data.refreshToken;
      const tokenData = decodeUserJWT(refreshToken);
      if (!tokenData) {
        return { rStatus: "error", message: "JWT could not be decoded" };
      }
      localStorage.setItem("refreshToken", refreshToken);
    }
    return { rStatus: "success" };
  }

  if (response.status === 202) {
    return {
      rStatus: "error",
      message: i18n.t("Data is missing required fields from the server")
    };
  }

  // 209
  if (response.status === 209) {
    if (
      response.data &&
      typeof response.data === "object" &&
      "message" in response.data &&
      typeof response.data.message === "string"
    ) {
      if (response.data.message.toLowerCase() === "email") {
        return { rStatus: "error", message: i18n.t("Email already exists") };
      }
      if (response.data.message.toLowerCase() === "nickname") {
        return {
          rStatus: "error",
          message: i18n.t("Nickname already exists")
        };
      }
    }

    return { rStatus: "error", message: i18n.t("Account already exists") };
  }

  return { rStatus: "error", message: i18n.t("An error occurred") };
}

export async function login(
  email: string,
  password: string
): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; rMessage: string }
> {
  console.log("HIT LOGIN");
  Swal.fire({
    title: i18n.t("Logging in"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });

  const md5password = md5(password);
  // loginToken: base64(email+md5(password)) as string
  const loginToken = btoa(`${email}&${md5password}`);
  const response = await apiFetcher({
    route: "/auth/login",
    method: "POST",
    options: {
      body: {
        loginToken: loginToken
      }
    }
  });
  console.log("loginToken", loginToken);
  console.log(response, "response");
  // nickname, bid_token
  // add token to local storage
  if (response.status === 200) {
    if (
      response.data &&
      typeof response.data === "object" &&
      "refreshToken" in response.data &&
      typeof response.data.refreshToken === "string"
    ) {
      const refreshToken = response.data.refreshToken;
      const tokenData = decodeUserJWT(refreshToken);
      if (!tokenData) {
        console.error("JWT could not be decoded");
        return { rStatus: "error", rMessage: i18n.t("An error occurred") };
      }
      localStorage.setItem("refreshToken", refreshToken);
      console.log("refreshToken", refreshToken);
    }

    return { rStatus: "success" };
  }

  console.log(response, "response");

  if (
    response.status === 204 ||
    response.status === 401 ||
    response.status === 403
  ) {
    return {
      rStatus: "error",
      rMessage: i18n.t("Email or password is incorrect")
    };
  }

  return { rStatus: "error", rMessage: i18n.t("An error occurred") };
}

export async function resetPassword(email: string): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; rMessage: string }
> {
  Swal.fire({
    title: i18n.t("Sending reset email"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });
  try {
    const response = await apiFetcher({
      route: "/auth/forgot",
      method: "POST",
      options: {
        body: {
          email: email
        }
      }
    });

    console.log(response, "response");

    if (response.status === 202) {
      return { rStatus: "success" };
    }

    if (response.status === 204) {
      return { rStatus: "error", rMessage: i18n.t("Email does not exist") };
    }

    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  } catch (error) {
    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  }
}

export async function resetPasswordSubmit(
  email: string,
  password: string,
  token: string
): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  Swal.fire({
    title: i18n.t("Resetting password"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });

  const md5password = md5(password);
  const response = await apiFetcher({
    route: "/auth/reset",
    method: "POST",
    options: {
      body: {
        email: email,
        password: md5password,
        emailToken: token
      }
    }
  });

  console.log(response, "response");

  if (response.status === 202) {
    return { rStatus: "success" };
  }

  return { rStatus: "error", message: "An error occurred" };
}

export async function submitMagicLink(email: string): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; rMessage: string }
> {
  Swal.fire({
    title: i18n.t("Sending magic link"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });
  try {
    const response = await apiFetcher({
      route: "/auth/magiclink",
      method: "POST",
      options: {
        body: {
          email: email
        }
      }
    });

    Swal.close();

    console.log(response, "response");

    if (response.status === 202) {
      return { rStatus: "success" };
    }

    if (response.status === 204) {
      return { rStatus: "error", rMessage: i18n.t("Email does not exist") };
    }

    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  } catch (error) {
    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  }
}

export async function requestNewRefreshToken(oldToken: string): Promise<
  | {
      rStatus: "success";
      rData: string;
    }
  | { rStatus: "error"; message: string }
> {
  console.log("requesting new refresh token");
  console.log(oldToken);
  // /auth/refresh

  const response = await apiFetcher({
    route: "/auth/refresh",
    method: "POST",
    options: {
      body: {
        refreshToken: oldToken
      }
    }
  });

  console.log(response, "response");

  if (response.status === 200) {
    if (
      response.data &&
      typeof response.data === "object" &&
      "refreshToken" in response.data &&
      typeof response.data.refreshToken === "string"
    ) {
      return { rStatus: "success", rData: response.data.refreshToken };
    }
  }

  return { rStatus: "error", message: "An error occurred" };
}

export async function checkIn(awaiting: boolean = false): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; rMessage: string }
> {
  try {
    const response = await apiFetcher({
      route: "/reward/checkIn",
      method: "POST",
      options: {
        body: {
          // refreshToken: localStorage.getItem("refreshToken")
        }
      }
    });

    console.log(response, "response");

    if (response.status === 202 || response.status === 209) {
      return { rStatus: "success" };
    }
    Swal.close();
    Swal.fire({
      title: "Error",
      html:
        `<strong class="font-extrabold">${i18n.t("An error occurred")}</strong>` +
        systemErrorAlertText(),
      icon: "error",
      confirmButtonText: "OK",
      customClass: {
        popup: "!rounded-lg",
        confirmButton:
          "!bg-secondary !rounded-full !outline-none !border-none !shadow-none"
      }
    });
    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  } catch (error) {
    return { rStatus: "error", rMessage: i18n.t("An error occurred") };
  }
}

export async function preSignUp(
  email: string,
  campaignSrc: string | null,
  referrerToken: string | null
): Promise<
  | {
      rStatus: "success";
    }
  | { rStatus: "error"; message: string }
> {
  Swal.fire({
    title: i18n.t("Signing up"),
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    customClass: {
      popup: "!rounded-lg swal-loading-custom"
    }
  });

  try {
    const response = await apiFetcher({
      route: "/auth/register",
      method: "POST",
      options: {
        body: {
          email: email,
          referrerToken: referrerToken,
          campaignSrc: campaignSrc
        }
      }
    });
    console.log(response, "response");

    if (response.status === 202 || response.status === 200) {
      return { rStatus: "success" };
    }

    if (response.status === 209) {
      if (
        response.data &&
        typeof response.data === "object" &&
        "message" in response.data &&
        typeof response.data.message === "string"
      ) {
        if (response.data.message.toLowerCase() === "email") {
          return { rStatus: "error", message: i18n.t("Email already exists") };
        }
        if (response.data.message.toLowerCase() === "nickname") {
          return {
            rStatus: "error",
            message: i18n.t("Nickname already exists")
          };
        }
      }

      return { rStatus: "error", message: i18n.t("Account already exists") };
    }

    if (response.status === 0) {
      return {
        rStatus: "error",
        message: i18n.t("Network error. Please try again later")
      };
    }

    return { rStatus: "error", message: i18n.t("An error occurred") };
  } catch (error) {
    return { rStatus: "error", message: i18n.t("An error occurred") };
  }
}
